export default __webpack_public_path__ + "bd7f69686faab2cd22cd756f2743839e.png";